import React from "react"

import Layout from "../components/Layout"
import SignupForm from "../components/SignupForm"
import SEO from "../components/SEO"

export default function SignUpPage() {
  return (
    <Layout className="mt-40">
      <SEO
        title="Sign Up"
        description="Get started on building resilient incident response plans. Free 14 day trial of our Growth plan. Build for rapid acknowledgement, collaboration and triaging of critical events."
      />
      <div className="container pb-40">
        <div>
          <h1 className="text-2xl text-center ">
            Start your <span className="text-secondary">Free Trial</span>
          </h1>
          <div className="text-md  text-subtle flex-row text-center pt-2 mb-8">
            No Credit card Required.
          </div>
          <div className="max-w-sm m-auto">
            <SignupForm />
          </div>
        </div>
      </div>
    </Layout>
  )
}
